
@if(showProModal()){
    <div class="fixed inset-0 z-[999] flex items-center justify-center overflow-y-auto bg-[rgba(0,0,0,0.55)] overlay pro-modal-overlay p-[16px]"
        role="dialog" aria-modal="true" (click)="closePricingPop()">
        <div class="relative flex w-fit max-w-full flex-col rounded-[8px] bg-white shadow-[0_18px_45px_rgba(0,0,0,0.24)] pricing-popover pro-modal-panel max-h-[calc(100vh-32px)] overflow-y-auto"
            (click)="$event.stopPropagation()">
            <button (click)="closePricingPop()" class="absolute top-[4px] right-[16px] h-[28px] w-[28px] cursor-pointer border-0 bg-transparent text-[30px] text-[#757575] pricing-popover-close
                md:top-[4px] md:right-[16px]
                max-md:top-[-4px] max-md:right-[4px] max-md:h-[44px] max-md:w-[44px] max-md:p-[8px]"
                aria-label="Close popover">
                ×
            </button>
            <div class="flex items-stretch lg:max-w-fit xl:max-w-auto max-md:flex-col-reverse max-md:items-start max-md:min-h-auto">
                <!-- LEFT COLUMN -->
                <div class="bg-[#FCF9F1] lg:flex-none lg:w-[322px] xl:flex-none xl:w-[362px]  lg:px-5 pt-0 h-[590px]
                max-md:flex-none max-md:w-full max-md:h-fit max-md:border-r-0 max-md:border-b max-md:border-[#E4E7EC]
                max-md:bg-white max-md:p-[20px_16px] pro-modal-left rounded-lg">
                    <img [src]="environment.homeImageUrl + 'img-pro.svg'" class="xl:w-[340px] h-[260px] lg:w-[320px] max-md:hidden" alt="" />

                    <div class=" mb-3.5 text-lg font-semibold text-title max-md:hidden">
                        What you get on the {{ selectedPlan()?.name ?? 'Standard' }} Plan
                    </div>

                    <div class="mb-[16px] text-xs font-medium text-[#667085] max-md:mb-[10px]">
                        Limits reset every month
                    </div>

                    <ul class="flex flex-col gap-3.5 max-md:gap-2.5 m-0 mb-[17px] list-none p-0 text-sm text-[#212121] feature-list">
                        @for (benefit of (selectedPlan()?.benefits ?? []); track benefit.key) {
                        <li
                            class="flex items-center justify-between feature-item max-md:flex-row-reverse max-md:h-[14px] max-md:py-[10px]">
                            <span
                                class="max-md:text-start max-md:self-start text-[#344054] text-sm font-medium max-md:text-sm">
                                {{ benefit.label }}
                            </span>
                            <span
                                class="inline-flex max-md:min-w-[55px] min-w-[40px] items-center justify-end feature-meta max-md:min-w-[14px] max-md:justify-start">
                                @if (benefit.value === true) {
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none">
                                    <path d="M5 14.5C5 14.5 6.5 14.5 8.5 18C8.5 18 14.0588 8.83333 19 7" stroke="#667085"
                                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                </svg>
                                } @else if (benefit.value === false) {
                                <span
                                    class="font-semibold text-right feature-number max-md:flex max-md:min-w-[65px] max-md:items-center max-md:justify-start max-md:text-[14px]">
                                    ×
                                </span>
                                } @else {
                                <span
                                    class="font-semibold text-right feature-number max-md:flex max-md:w-full max-md:items-center max-md:justify-start max-md:text-[14px]">
                                    {{ benefit.value }}
                                </span>
                                }
                            </span>
                        </li>
                        }
                    </ul>

                    <a [href]="pricingPageUrl"
                        class="text-[#101828] underline underline-offser-2 text-[16px] font-[500] leading-[24px] max-md:text-[12px]">
                        See More
                    </a>
                </div>

                <!-- RIGHT COLUMN -->
                <div
                    class="flex lg:w-[410px] xl:w-[530px] right-side-max-width h-[590px] pro-modal-right flex-col p-[26px] mb-1 pricing-popover-right max-md:h-fit max-md:w-full max-md:max-w-full max-md:p-[18px_18px_0px]">
                    <div class="mb-[6px] flex items-center pro-header max-md:pb-1 ">
                        <div>
                            <img [src]="environment.homeImageUrl + 'bdjobs_pro.svg'" 
                                class="w-[150px] h-[27px] logo-pro max-md:w-[149px] max-md:h-[26px]" alt="" />
                        </div>
                    </div>

                    <p
                        class="message mt-[7px] mb-[34px] max-w-[495px] text-sm font-[400] text-[#616161] pro-subtitle max-md:mt-0 max-md:pt-0 max-md:mb-[34px] max-md:text-[14px]">
                        A smart assistant for your career journey!
                    </p>

                    <!-- Billing tabs -->
                    <div
                        class="billing-tabs relative border border-[#E4E7EC] button-bottom-margin mb-4 flex h-[44px] w-full md:w-[334px] rounded-full bg-[#F9FAFB] p-[6px] max-md:mb-[10px] max-md:h-[42px] max-md:w-full max-md:items-center">
                        <div>
                            <img [src]="environment.homeImageUrl + 'swingArrow.png'" class="absolute -top-[26px] -right-32 md:block hidden img-hide" alt="" />
                        </div>
                        <div class="billing-pill" [class.monthly]="selectedbill() === 'monthly'"
                            [class.quarterly]="selectedbill() === 'quarterly'" [class.yearly]="selectedbill() === 'yearly'"></div>
                    
                        <button
                            class="billing-btn relative z-[2] h-[34px] min-w-0 flex-1 whitespace-nowrap rounded-full border-0 px-[14px] py-[6px] text-[12px] font-[600] leading-[20px] cursor-pointer max-md:h-[30px] max-md:text-[12px]"
                            [class.billing-active-text]="selectedbill() === 'monthly'"
                            [class.billing-inactive-text]="selectedbill() !== 'monthly'" (click)="onBillingSelect('monthly')">
                            Monthly
                        </button>
                    
                        <button
                            class="billing-btn relative z-[2] h-[34px] min-w-0 flex-1 whitespace-nowrap rounded-full border-0 px-[14px] py-[6px] text-[12px] font-[600] leading-[20px] cursor-pointer max-md:h-[30px] max-md:text-[12px]"
                            [class.billing-active-text]="selectedbill() === 'quarterly'"
                            [class.billing-inactive-text]="selectedbill() !== 'quarterly'" (click)="onBillingSelect('quarterly')">
                            Quarterly
                            <div class="billing-badge absolute bottom-[34px] left-1/2 z-[3] -translate-x-1/2 max-md:bottom-[30px]">
                                <img class="block" 
                                    [class.max-w-none]="selectedbill() === 'quarterly'"
                                     style="width: auto; height: auto;"
                                  [src]="environment.homeImageUrl + '50_Badge.svg'" alt="" />
                            </div>
                        </button>
                    
                        <button
                            class="billing-btn relative z-[2] h-[34px] min-w-0 flex-1 whitespace-nowrap rounded-full border-0 px-[14px] py-[6px] text-[12px] font-[600] leading-[20px] cursor-pointer max-md:h-[30px] max-md:text-[12px]"
                            [class.billing-active-text]="selectedbill() === 'yearly'"
                            [class.billing-inactive-text]="selectedbill() !== 'yearly'" (click)="onBillingSelect('yearly')">
                            Yearly
                            <div class="billing-badge absolute bottom-[34px] left-1/2 z-[3] -translate-x-1/2 max-md:bottom-[30px]">
                                <img class="block"
                                    [class.max-w-none]="selectedbill() === 'yearly'"
                                    style="width: auto; height: auto;"
                                    [src]="environment.homeImageUrl + '75_%20Badge.svg'" alt="" />
                            </div>
                        </button>
                    </div>
                    <!-- Plans -->
                    <div
                        class="plans mb-[16px] flex flex-col gap-2.5 max-md:mb-0 max-md:grid max-md:grid-cols-3 max-md:gap-[8px]">
                        <div class="text-[16px] font-[600] leading-[24px] text-[#475467] max-md:hidden">
                            Packages</div>

                        @for (plan of selectedPlans(); track $index) {
                            <div (click)="onPlanSelect(plan)" class="relative flex h-[85px] cursor-pointer items-center justify-between rounded-[10px] p-[12px_14px] plan-card
                                    max-md:h-[70px] max-md:justify-start max-md:p-2 max-md:pb-1" [ngClass]="
                                selectedPlanId() === plan.id
                                ? 'border-[2px] border-[#C63C92] bg-[#FCF3FA]'
                                : 'border border-[#E4E7EC] bg-[#fafafa] hover:border-[#FCF3FA] hover:bg-[#FCF3FA]'
                            ">
                                <div class="min-h-full flex flex-col justify-between">
                                    <div class="flex items-center gap-[6px]">
                                        <span class="text-base font-medium text-[#475467] max-md:text-[12px]">
                                        {{plan.name}}
                                        </span>
                                    </div>
                            
                                    <div class="flex items-baseline gap-1.5 text-[14px] text-[#212121] max-md:flex-col max-md:text-[30px]">
                                        <div class=" font-semibold text-[#C63C92] max-md:h-full text-[20px]">
                                            ৳{{plan.discountedPrice}}
                                        </div>
                            
                                        @if (selectedbill() !== 'monthly') {
                                            <div class="text-base text-[#667085] font-medium max-md:hidden">
                                                <span class="line-through">৳{{plan.price}}</span>
                                                <span> /{{billingLabel[selectedbill()]}}</span> 
                                            </div>                   
                                            <div
                                                class="ml-0.5 self-center rounded-[12px] border border-[#B9E6FE] bg-[#F0F9FF] px-[6px] py-[2px] text-[10px] font-medium text-[#026AA2] plan-tag max-md:hidden">
                                                {{plan.discountText}}
                                            </div>
                                        }
                                    </div>
                                </div>
                            
                                <div class="absolute top-[12px] right-[12px] inline-flex items-center justify-center rounded-full plan-radio
                                        max-md:top-[4px] max-md:right-[4px]" [ngClass]="
                                    selectedPlanId() === plan.id
                                    ? 'h-[16px] w-[16px] border-2 border-[#C63C92] bg-[#C63C92] max-md:h-[12px] max-md:w-[12px] max-md:border max-md:border-[#C63C92]'
                                    : 'h-[16px] w-[16px] border-2 border-[#E4E7EC] bg-transparent max-md:h-[12px] max-md:w-[12px] max-md:border max-md:border-[#D0D5DD]'
                                ">
                                    <div class="h-[6px] w-[6px] rounded-full plan-radio-dot"
                                        [ngClass]="selectedPlanId() === plan.id ? 'bg-white' : 'bg-transparent'"></div>
        </div>
                            </div>
                        }
                            
                    </div>

                    <!-- Desktop footer -->
                    <div class="flex flex-col gap-3 max-md:hidden">
                        <button type="button" (click)="redirectToPayment()"
                            [disabled]="isPaymentRedirecting()"
                            [attr.aria-busy]="isPaymentRedirecting()"
                            class="inline-flex h-[48px] w-full cursor-pointer items-center justify-center gap-[6px] rounded-[8px] border-0
                    bg-[#079455] px-[18px] py-[12px] text-[14px] font-[600] text-white hover:bg-[#067647] disabled:pointer-events-none disabled:opacity-90"
                            >
                            @if (isPaymentRedirecting()) {
                                <span class="pro-payment-spinner shrink-0" aria-hidden="true"></span>
                            } @else {
                                <span class="btn-label">Get Bdjobs Pro</span>
                                <img class="ml-[6px] h-[16px] w-[16px] pt-[2px] icon-arrow"
                                    [src]="environment.homeImageUrl + 'arrow-icon.svg'" alt="" aria-hidden="true" />
                            }
                        </button>

                        <div class="text-center text-[14px] font-normal text-[#475467]">
                            Need help? <span class="font-[500]">09638666444</span> or <span
                                class="font-[500]">01897627858</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Mobile footer -->
            <div class="hidden w-full p-[0px_18px_16px]  max-md:block">
                <button type="button" (click)="redirectToPayment()"
                    [disabled]="isPaymentRedirecting()"
                    [attr.aria-busy]="isPaymentRedirecting()"
                    class="inline-flex h-[40px] w-full cursor-pointer items-center justify-center gap-[6px] rounded-[8px] border-0
                bg-[#079455] px-[14px] py-[10px] text-[14px] font-[600] text-white hover:bg-[#067647] disabled:pointer-events-none disabled:opacity-90"
                    >
                    @if (isPaymentRedirecting()) {
                    <span class="pro-payment-spinner shrink-0" aria-hidden="true"></span>
                    } @else {
                    <span class="btn-label">Get Bdjobs Pro</span>
                    <img class="ml-[6px] h-[16px] w-[16px] pt-[2px] icon-arrow"
                        [src]="environment.homeImageUrl + 'arrow-icon.svg'" alt="" aria-hidden="true" />
                    }
                </button>

                <div class="mt-[12px] text-center text-[12px] font-[400] leading-[18px] text-[#475467] help-text">
                    Need help? <span class="font-[500]">09638666444</span> or <span class="font-[500]">01897627858</span>
                </div>
            </div>
        </div>
    </div>
}